import { render, staticRenderFns } from "./AssignTeacher.vue?vue&type=template&id=36b37278&scoped=true"
import script from "./AssignTeacher.vue?vue&type=script&lang=js"
export * from "./AssignTeacher.vue?vue&type=script&lang=js"
import style0 from "./AssignTeacher.vue?vue&type=style&index=0&id=36b37278&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b37278",
  null
  
)

export default component.exports